/**
 * @file   src\components\Introduction\GoogleMap.js
 * @brief  This file is responsible for the view of map.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React from "react";
import { GoogleMap, useJsApiLoader, Circle } from "@react-google-maps/api";
import { MAP_TYPE_ROADMAP } from "../../constants/common";
import { getMeters } from "../../helpers/common";

const GoogleMaps = (props) => {
    const {
        defaultProps,
        mapHeight,
        mapWidth,
    } = props;

    // Initialize component state variables and constants.
    const googleMapApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    const mapRadius = 1;
    const radius = mapRadius && getMeters(mapRadius); // 10 kilometers

    const { isLoaded } = useJsApiLoader({
        // for checking map script is loaded in the UI.
        id: "google-map-script",
        googleMapsApiKey: googleMapApiKey,
    });

    const circleOptions = {
        strokeColor: "#338BA8",
        strokeOpacity: 0,
        strokeWeight: 1,
        fillColor: "#338BA8",
        fillOpacity: 0.35,
    };

    const containerStyle = {
        width: mapWidth,
        height: mapHeight,
    };

    return (
        isLoaded &&
        _.get(defaultProps.center, "lat", "") && (

            <GoogleMap
                mapTypeId={MAP_TYPE_ROADMAP}
                mapContainerStyle={containerStyle}
                center={defaultProps.center}
                zoom={defaultProps.zoom}
                mapContainerClassName="wantad-map-wrap overflow-hidden"
            >
                <Circle
                    center={defaultProps.center}
                    radius={radius}
                    options={circleOptions}

                />

            </GoogleMap>

        )
    );
};
export default GoogleMaps;
